<template>
  <h2 class="content-block">User Profile</h2>

  <div class="content-block dx-card responsive-paddings profile-card">
    <DxForm id="form" 
        :form-data="user" 
        :label-mode="outside" 
        :read-only="true" 
        :show-colon-after-label="true"
        :label-location="top" 
        :col-count="1" 
        :min-col-width="300" 
        :width="null"
        :items="['userId', 'userName', 'firstName', 'surname']"
      >
      <!-- :items="['containerTypeId', 'containerTypeName']" -->
      <!-- <DxSimpleItem data-field="containerTypeId"  :editor-options="{readOnly: true}" /> -->
      <!-- <DxSimpleItem data-field="containerTypeName" /> -->
      
    </DxForm>

  </div>
  <div class="content-block dx-card responsive-paddings profile-card" id="preferences">
    <DxForm
        ref="preferencesForm"
        :form-data="user"
        :col-count="1"
        :min-col-width="300"
        :width="null">
      <DxSimpleItem editor-type="dxSelectBox" data-field="measurementSystem" :is-required="true"
        :editor-options="{ items: ['Metric','Imperial'], searchEnabled: true}"/>
      <DxGroupItem :col-count="2">
        <DxSimpleItem editor-type="dxSelectBox" data-field="timeZone" :is-required="true"
          :editor-options="{ items: timezones, searchEnabled: true}"/>
        <DxSimpleItem template="currentTime">
          <DxLabel text="Current Time" />
        </DxSimpleItem>
      </DxGroupItem>

      <template #currentTime>
        <TimezoneClock :time-zone="user?.timeZone" />
      </template>
    </DxForm>

    <DxButton text="Save Preferences" @click="updatePreferences()"/>
  </div>
  <div class="content-block dx-card responsive-paddings profile-card" id="pwreset">
    
    <DxTextBox class="tb" label="Enter New Password" mode="password" :show-clear-button="true" v-model:value="resetPassword1" :input-attr="inputAttr">
      <DxValidator name="password">
        <DxStringLengthRule min="6" />
      </DxValidator>
    </DxTextBox>
    <DxTextBox class="tb" label="Renter Password" mode="password" :show-clear-button="true" v-model:value="resetPassword2" :input-attr="inputAttr">
      <DxValidator name="password">
        <DxStringLengthRule min="6" />
      </DxValidator>
    </DxTextBox>

    <DxButton text="Update Password" @click="updatePassword()"/>
  </div>
  <DxToast
      v-model:visible="toastVisible"
      v-model:message="toastMessage"
      v-model:type="toastType"
      :position="toastPosition"
    />
</template>

<script>

import DxForm, { DxSimpleItem, DxGroupItem, DxLabel } from "devextreme-vue/form";
import DxTextBox from "devextreme-vue/text-box";
import { DxButton } from 'devextreme-vue/button';
import {
    DxValidator,
    DxStringLengthRule
} from 'devextreme-vue/validator';
import { DxToast } from 'devextreme-vue/toast';
import TimezoneClock from '@/components/custom/timezone-clock.vue';

export default {
  components: {
    DxForm,
    DxSimpleItem,
    DxGroupItem,
    DxLabel,
    TimezoneClock,
    DxTextBox,
    DxButton,
    DxValidator,
    DxStringLengthRule,
    DxToast,
  },
  created() {
    this.loadPageData();
  },
  data() {
    return {
      toastVisible: false,
      toastMessage: '',
      toastType: 'info',
      // anchored to the viewport so the toast is visible regardless of scroll position
      toastPosition: {
          at: "bottom",
          my: "bottom",
          of: window,
          offset: "0 -24"},
      resetPassword1: "",
      resetPassword2: "",
      inputAttr: {
        mode: "password",
        inputAttr: {
          autocomplete: "off" //"new-password"
        }
      },
      // saveButtonOptions: {
      //   icon: 'save',
      //   onClick: () => {
      //     if (this.containerTypes.containerTypeId==0)
      //     {
      //       this.$store.dispatch('containerTypes/addContainerType', this.containerTypes);
      //       this.$emit('recordUpdated');
      //     }
      //     else
      //     {
      //       this.$store.dispatch('containerTypes/updateContainerType', this.containerTypes);
      //       this.$emit('recordUpdated');
      //     }
      //   },
      // },
    };
  },
  computed: {
    currentRecordId() {
      return this.$route.path.substring(this.$route.path.lastIndexOf('/') + 1); 
    },
    user() {
      return this.$store.getters["users/getProfile"];
    },
    timezones() {
      return this.$store.getters["timezone/allAmericanTimezones"];
    },
  },
  methods: {
    async updatePreferences(){
      if (!this.$refs.preferencesForm.instance.validate().isValid)
      {
        this.toastType = 'error';
        this.toastMessage = 'Please select a measurement system and timezone.';
        this.toastVisible = true;
        return;
      }
      try {
        await this.$store.dispatch('users/updateProfilePreferences', this.user);
        this.toastType = 'success';
        this.toastMessage = 'Preferences saved.';
      } catch (error) {
        this.toastType = 'error';
        this.toastMessage = 'Error saving preferences.';
      }
      this.toastVisible = true;
    },
    updatePassword(){
      if (this.resetPassword1 === this.resetPassword2 && this.resetPassword1.length>=6)
      {
        this.$store.dispatch('users/updateProfile',  { pw: this.resetPassword1 });
        this.toastType = 'success';
        this.toastMessage = 'Password successfully reset.';
        this.toastVisible = true;
      }
      else
      {
        this.toastType = 'error';
        this.toastMessage = 'Error resetting password.';
        this.toastVisible = true;
      }
    },
    refreshData(){
      this.loadPageData();
    },
    async loadPageData(refresh = false) {
      try {
        await this.$store.dispatch("users/loadProfile", { refresh: true });
      } catch (error) {
        this.error = error.message || "Unexpected Error.";
      }
     
    },
  },
};
</script>

<style scoped>
.profile-card.responsive-paddings {
  padding-top: 24px;
  padding-bottom: 24px;
}
#pwreset {
  margin-bottom: 20px;
}
.tb{
  margin: 0 0 20px 0px;
}
</style>
